import yup from '@/utils/yup-global'

// Schema cho user đã đăng nhập
export const reviewSchemaAuthenticated = yup.object().shape({
  rating: yup
    .number()
    .min(1, 'Vui lòng chọn mức đánh giá')
    .max(5, 'Đánh giá tối đa là 5 sao')
    .required('Vui lòng chọn mức đánh giá'),
  content: yup.string().required('Vui lòng nhập nội dung đánh giá'),
})

// Schema cho guest (chưa đăng nhập)
export const reviewSchemaGuest = yup.object().shape({
  rating: yup
    .number()
    .min(1, 'Vui lòng chọn mức đánh giá')
    .max(5, 'Đánh giá tối đa là 5 sao')
    .required('Vui lòng chọn mức đánh giá'),
  content: yup.string().required('Vui lòng nhập nội dung đánh giá'),
  name: yup.string().required('Vui lòng nhập tên của bạn'),
})

// Giữ lại schema cũ để tương thích ngược (mặc định dùng cho authenticated)
export const reviewSchema = reviewSchemaAuthenticated

export type IReviewFormValuesAuthenticated = yup.InferType<typeof reviewSchemaAuthenticated>
export type IReviewFormValuesGuest = yup.InferType<typeof reviewSchemaGuest>
export type IReviewFormValues = IReviewFormValuesAuthenticated | IReviewFormValuesGuest
